import { Injectable } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { environment } from "src/environments/environment";
import { CustomerAssignment } from "./customer-administration.model";

@Injectable()
export class CustomerAdministrationService {

    constructor(
        private http: HttpService
    ) { }

    async getAssignments(): Promise<CustomerAssignment[]> {
        return await this.http.get<CustomerAssignment[]>(`${environment.adminConfig.apiUri}/customer/assignments`);
    }

    async saveCustomerAssignment(assignment: CustomerAssignment): Promise<CustomerAssignment> {
        return await this.http.post<CustomerAssignment, CustomerAssignment>(`${environment.adminConfig.apiUri}/customer/${assignment.customerId}/assignment`, assignment);
    }
}
    